import React from 'react';

const Permissions = () => {
    return (
        <div>
            טבלת הרשאות
        </div>
    );
};

export default Permissions;